import { render, staticRenderFns } from "./EditInserts.vue?vue&type=template&id=52e576b4&"
import script from "./EditInserts.vue?vue&type=script&lang=js&"
export * from "./EditInserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports